import { createAsyncThunk } from '@reduxjs/toolkit';

import { DOCUMENT_TYPES } from '@backrs_ui/grow-ui/src/models/models';

import { userDocumentsApi } from '../user.lubav.api';

export const checkUserDocuments = createAsyncThunk(
  'user/checkUserDocuments',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      // Force a fresh API call by using refetch with forceRefetch option whenever thunk is called
      const result = await dispatch(
        userDocumentsApi.endpoints.checkUserDocuments.initiate(
          {
            documents: Object.values(DOCUMENT_TYPES),
          },
          { forceRefetch: true },
        ),
      ).unwrap();

      return result;
    } catch (error) {
      return rejectWithValue('Failed to check user resume: ' + error);
    }
  },
);
